<template>
  <div class="row g-4">
    <div class="col-12">
      <h2 class="h4 mb-2">{{ options.question || 'Besteht auch eine Übernachtungsmöglichkeit?' }}</h2>
      <p class="text-secondary mb-0">
        Geben Sie an, ob Unterkünfte dazugehören, und wählen Sie dann nur die passenden Typen aus.
      </p>
    </div>

    <div class="col-12">
      <label :for="options.storeKey" class="form-label fw-semibold">{{ accommodationLabel }} vorhanden?</label>
      <Field as="select" v-model="surveyStore.data[options.storeKey].select" :id="options.storeKey"
             :name="options.storeKey"
             class="form-select" :class="{'is-invalid': errors[options.storeKey]}">
        <option value="">Bitte auswählen</option>
        <option value="true">Ja</option>
        <option value="false">Nein</option>
      </Field>
      <div v-if="errors[options.storeKey]" class="invalid-feedback">
        {{ errors[options.storeKey] }}
      </div>
    </div>

    <div class="col-12">
      <div class="alert alert-primary border-0 mb-0">
        <div class="fw-semibold mb-2">Tipp</div>
        <div
          v-if="surveyStore.data[options.storeKey].select === 'true' && options.tipp"
          class="small text-body mb-2"
          v-html="options.tipp"
        ></div>
        <p class="mb-0">Sie können {{ laterAccommodationText }} später auch einzeln ergänzen oder anpassen.</p>
      </div>
    </div>

    <div class="col-12" v-if="surveyStore.data[options.storeKey].select === 'true'">
      <div class="row g-3">
        <div class="col-12">
          <div class="row g-3">
            <template :key="checkbox.key" v-for="checkbox in availableCheckboxes">
              <div class="col-12">
                <div v-if="checkbox.key in surveyStore.data[options.storeKey]" class="border p-3 h-100">
                  <div class="form-check mb-0">
                    <Field type="checkbox" :name="checkbox.field_names.checked">
                      <input
                        type="checkbox"
                        v-model="surveyStore.data[options.storeKey][checkbox.key].checked"
                        :name="checkbox.field_names.checked"
                        :id="checkbox.key"
                        class="form-check-input"
                        value="true"
                      />
                      <label class="form-check-label fw-semibold" :for="checkbox.key">
                        {{ checkbox.label }}
                      </label>
                    </Field>
                  </div>

                  <div v-if="surveyStore.data[options.storeKey][checkbox.key].checked" class="mt-3 pt-3 border-top">
                    <div class="d-flex flex-column flex-md-row align-items-md-center gap-2 mb-3">
                      <label :for="`${checkbox.key}_count`" class="form-label fw-semibold mb-0">
                        Anzahl
                      </label>
                      <div class="d-flex align-items-center gap-2">
                        <Field as="input" type="number" min="1" max="999"
                               v-model="surveyStore.data[options.storeKey][checkbox.key].count"
                               :id="`${checkbox.key}_count`" value="1" :name="`${checkbox.key}_count`"
                               class="form-control custom-input">
                        </Field>
                        <span class="text-secondary">{{ checkbox.count_label }}</span>
                      </div>
                    </div>

                    <ZusatzobjekteDetails :group="options.storeKey" :model="checkbox.key" :checkbox="checkbox"
                                          :errors="errors"/>
                  </div>
                </div>
                <div v-else class="text-danger small">
                  Missing {{ checkbox.key }} in surveyStore
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field} from 'vee-validate';
import ZusatzobjekteDetails from "./ZusatzobjekteDetails";

export default {
  components: {
    Field,
    ZusatzobjekteDetails
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  props: {
    errors: Object,
    options: {
      type: Object,
    }
  },
  computed: {
    isAccommodationObjectType() {
      return this.surveyStore.data.objekttyp === 'unterkunft'
    },
    accommodationLabel() {
      return this.isAccommodationObjectType ? 'Weitere Unterkünfte' : 'Unterkünfte'
    },
    laterAccommodationText() {
      return this.isAccommodationObjectType ? 'weitere Unterkünfte' : 'Unterkünfte'
    },
    availableCheckboxes() {
      return this.surveyStore.currentConfig.currentStep?.[this.options.storeKey]?.checkboxes || []
    }
  },
  methods: {},

}
</script>
<style scoped lang="scss">
.custom-input {
  width: 5rem;
  text-align: center;
}
</style>
